function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAlarm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.529 17.434h6.921a3.463 3.463 0 0 1-6.921 0zm-5.529 0zm1.932 0V9.082l.011-.19c.217-3.121 3.31-5.566 7.048-5.566s6.827 2.445 7.044 5.566l.011.162v8.38zM8.991 0z",
  "data-name": "Union 25",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.3px"
  },
  transform: "translate(7.012 5.621)"
}));
export default SvgIconAlarm;